// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1_ZsV","cls2":"LandingScreen-cls2_09K LandingScreen-cls1_ZsV"};